
import configService from '@core/services/configs/ConfigService';
import RestRequestFactory, { RestClient } from '@core/utils/network/RestRequestFactory';

export default class AllowancesRestService {
    public async getAllowances(): Promise<string> {
        const allowancesUrl = (await configService.getConfig()).tickets.allowancesUrl;
        const allowancesApi = RestRequestFactory.create(
           allowancesUrl
        );
        const allowances = await allowancesApi.get('');

        // Since the multiplatform libs expects raw JSON to parse
        return JSON.stringify(allowances);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/terminal/core/services/allowances/_private/AllowancesRestService.ts